// extracted by mini-css-extract-plugin
export default {"container":"offers_container__B2bxR","heading":"offers_heading__Lq2Wd"};